<template>
  <div class="pc-pagin">
    <button
      class="pc-pagin-firstPage iconfont"
      @click="goFirstPage"
      :disabled="this.pagination.page == 1"
      :class="{
        disabled: this.pagination.page == 1,
      }"
    >
      &#xe600;
    </button>

    <el-pagination
      class="pc-pagin-bar"
      @current-change="handleCurrentChange"
      :page-size="pagination.take"
      :current-page="pagination.page"
      layout="prev, pager, next"
      :total="pagination.total"
    >
    </el-pagination>

    <button
      class="pc-pagin-lastPage iconfont"
      @click="goLastPage"
      :disabled="
        Math.ceil(this.pagination.total / this.pagination.take) ==
          this.pagination.page ||
        !this.pagination.total
      "
      :class="{
        disabled:
          Math.ceil(this.pagination.total / this.pagination.take) ==
            this.pagination.page ||
          !this.pagination.total,
      }"
    >
      &#xe601;
    </button>
    <div
      class="pc-pagin-go"
      :class="{ show: pagination.total / pagination.take <= 10 }"
    >
      <!-- <span>Go</span> -->
      <input
        class="pc-pagin-page-input"
        placeholder=""
        v-model="pageJump"
        @keyup.enter="goPage"
        type="text"
        @blur="checkNumber"
      />
      <!-- <span>/{{ Math.ceil(pagination.total / pagination.take) }}</span> -->
      <button class="pc-pagin-go-btn" @click="goPage">GO</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageJump: "",
    };
  },
  filters: {
    //  numFilter
    pageJump(value) {
      // 截取当前数据到小数点后两位
      if (String(value).indexOf(".") + 1 > 0) {
        let realVal = Number(value).toFixed(0);
        // let realVal= realVal+1
        realVal++;
        console.log("11,", realVal);
        return Number(realVal);
      } else {
        return Number(value);
      }
      // num.toFixed(2)获取的是字符串
    },
  },

  props: ["pagination"],

  methods: {
    checkNumber() {
      if (this.pageJump > this.pagination.total / this.pagination.take) {
        this.pageJump = Math.ceil(this.pagination.total / this.pagination.take);
      }
    },
    goPage() {
      if (
        Number(this.pageJump) &&
        Number(this.pageJump) <=
          this.pagination.total / this.pagination.take + 1
      ) {
        this.$emit("goPage", Number(this.pageJump));
        this.scrollTo();
      } else {
        return;
      }
    },
    handleCurrentChange(val) {
      this.pageJump = "";
      this.$emit("goPage", val);
      this.scrollTo();
    },
    goLastPage() {
      this.$emit(
        "goPage",
        Math.ceil(this.pagination.total / this.pagination.take)
      );
      this.scrollTo();
    },
    goFirstPage() {
      this.$emit("goPage", 1);
      this.scrollTo();
    },
    scrollTo() {
      if (this.pagination.scrollTop) {
        window.scrollTo(0, this.pagination.scrollTop);
        this.pageJump = "";
      }
    },
  },
};
</script>

<style lang="scss">
.pc-pagin {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
</style>
<style scoped lang="scss">
.pc-pagin {
  .pc-pagin-firstPage,
  .pc-pagin-lastPage {
    border: none;
    background: none;
    outline: none;
    line-height: 30px;
    color: $secondTitle;
    cursor: pointer;
    font-weight: 800;
  }

  .pc-pagin-firstPage {
    margin-right: 10px;
  }
  .pc-pagin-firstPage:hover,
  .pc-pagin-lastPage:hover {
    color: $blueBtn !important;
  }
  .pc-pagin-lastPage {
    margin-left: 10px;
  }
  .disabled {
    cursor: not-allowed;
    color: $thirdTitle;
  }
  .disabled:hover {
    color: $thirdTitle !important;
  }
  .show {
    display: none;
  }
  .pc-pagin-go {
    margin-left: 20px;
    .pc-pagin-page-input {
      height: 30px;
      width: 50px;
      border: 2px solid $border;
      outline: none;
      border-radius: 4px;
      margin: 0 6px;
      text-align: center;
      margin-right: 0;
    }
    span {
      color: $thirdTitle;
    }

    .pc-pagin-go-btn {
      height: 30px;
      width: 30px;
      background: $blueBtn;
      border: none;
      color: white;
      border-radius: 4px;
      outline: none;
      cursor: pointer;
      margin-left: 10px;
      font-size: 10px;
    }
  }
  /deep/ .pc-pagin-page-input {
    border: 1px solid $thirdTitle;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/componentSet/Pagination.vue